import { AuthenticatedImage } from '@components/AuthenticatedImage/AuthenticatedImage';
import { useMediaThumbnail } from '@lib/image/thumbnail';
import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';
import css from './MobileThumbnailGrid.module.scss';

const ThumbnailChoice = memo(
  ({
    mediaId,
    libraryId,
    isSelected,
    onSelect,
  }: {
    mediaId: string;
    libraryId: string;
    isSelected: boolean;
    onSelect: () => void;
  }) => {
    const thumbnailData = useMediaThumbnail(libraryId, mediaId);

    return (
      <button
        className={classNames(css.thumbnailButton, isSelected && css.selected)}
        onClick={onSelect}
        type="button"
      >
        {thumbnailData?.url ? (
          <AuthenticatedImage
            src={thumbnailData.url}
            alt={mediaId}
            className={css.thumbnailImage}
            token={thumbnailData.token}
          />
        ) : (
          <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }} />
        )}
        {isSelected && <div className={css.selectedIndicator} />}
      </button>
    );
  },
);

ThumbnailChoice.displayName = 'MobileThumbnailChoice';

interface MobileThumbnailGridProps {
  libraryId: string;
  folderFiles: any[];
  selectedMediaId: string;
  onSelectMedia: (mediaId: string) => void;
}

export const MobileThumbnailGrid = memo(
  ({ libraryId, folderFiles, selectedMediaId, onSelectMedia }: MobileThumbnailGridProps) => {
    return (
      <div className={css.grid}>
        {folderFiles.map((media) => (
          <ThumbnailChoice
            key={media._id}
            mediaId={media._id}
            libraryId={libraryId}
            isSelected={media._id === selectedMediaId}
            onSelect={() => onSelectMedia(media._id)}
          />
        ))}
      </div>
    );
  },
);

MobileThumbnailGrid.displayName = 'MobileThumbnailGrid';
